import type { WShopNewProductsTranslations } from "./pl";

export const en: WShopNewProductsTranslations = {
  title: "New products",
  showAll: "See all",
  noProducts: "No new products.",
};
